Vue.component("FreshChat", {
  props: ["config"],
  template: `
        <transition enter-active-class="fadeIn" leave-active-class="fadeOut">
           <div class="FreeChat">
                <iframe src="assets/components/freechat.html"></iframe>
           </div>
        </transition>
    `,
  data() {
    return {};
  },
  mounted() {
    const chatCfg = {
      token: this.config.token,
      tags: this.config.tags,
      headerProperty: this.config.headerProperty,
    };

    this.$nextTick().then(() => {
      const iframe = this.$el.querySelector("iframe").contentWindow;
      var scout = setInterval(() => {
        if (iframe.hasOwnProperty("ping") && iframe.ping()) {
          clearInterval(scout);
          iframe.initializeChat(chatCfg);
        }
      }, 33);
    });
  },
});
